import { render, staticRenderFns } from "./RequestFooterPanel.vue?vue&type=template&id=6b97cc73"
import script from "./RequestFooterPanel.vue?vue&type=script&lang=js"
export * from "./RequestFooterPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports